class ViewerCount extends HTMLElement {
  connectedCallback() {
    const productId = this.dataset.productId;
    const min = parseInt(this.dataset.min, 10) || 3;
    const max = parseInt(this.dataset.max, 10) || 25;
    const template = this.dataset.text || '{count} people viewing this item';
    const storageKey = `viewer-count-${productId}`;

    let count = sessionStorage.getItem(storageKey);
    if (!count) {
      count = Math.floor(Math.random() * (max - min + 1)) + min;
      sessionStorage.setItem(storageKey, count);
    }

    const textEl = this.querySelector('.viewer-count__text');
    if (textEl) {
      textEl.textContent = template.replace('{count}', count);
    }
  }
}

customElements.define('viewer-count', ViewerCount);